(function ($, root, undefined) {

	// ======================================
	// RELOAD PAGE ON AXEPTIO CONSENT CHANGE
	// ======================================
	
	// Vérifier si on vient d'un rechargement pour éviter le rechargement au chargement initial
	var isReloadFromAxeptio = sessionStorage.getItem('axeptio_reload_triggered');
	if (isReloadFromAxeptio) {
		sessionStorage.removeItem('axeptio_reload_triggered');
	}
	
	var axeptioReloadDone = false;
	var userActionDetected = false;
	
	// Détecter les clics dans l'overlay Axeptio (action utilisateur)
	document.addEventListener('click', function(e) {
		var overlay = e.target.closest('#axeptio_overlay');
		if (overlay) {
			userActionDetected = true;
		}
	}, true);
	
	// Écouter l'événement Axeptio cookies:complete pour recharger la page
	void 0 === window._axcb && (window._axcb = []);
	window._axcb.push(function (axeptio) {
		axeptio.on("cookies:complete", function (choices) {
			// Ne recharger que si c'est une action utilisateur
			if (!userActionDetected || axeptioReloadDone) {
				return;
			}
			
			axeptioReloadDone = true;
			sessionStorage.setItem('axeptio_reload_triggered', 'true');
			
			setTimeout(function() {
				window.location.reload();
			}, 200);
		});
	});


	// ======================================
	// FONCTIONS DE GESTION D'URL (PORTÉE GLOBALE)
	// ======================================
	
	// Fonctions pour gérer les paramètres d'URL
	function getUrlParameter(name) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(name);
	}

	function getUrlParameters() {
		const urlParams = new URLSearchParams(window.location.search);
		const params = {};
		for (const [key, value] of urlParams) {
			if (key === 'entite' || key === 'categorie') {
				// Séparer les valeurs par underscore pour les arrays
				params[key] = value.split('_').filter(v => v.length > 0);
			} else {
				params[key] = value;
			}
		}
		return params;
	}

	function updateUrlParameters(params, replaceState = false) {
		const url = new URL(window.location);
		
		// Vider tous les paramètres existants
		url.search = '';
		
		// Ajouter les nouveaux paramètres
		Object.keys(params).forEach(key => {
			if (Array.isArray(params[key]) && params[key].length > 0) {
				// Joindre les valeurs avec des underscores (jamais encodé dans les URLs)
				url.searchParams.set(key, params[key].join('_'));
			} else if (params[key]) {
				url.searchParams.set(key, params[key]);
			}
		});

		// Mettre à jour l'URL sans rafraîchir la page
		if (replaceState) {
			window.history.replaceState({}, '', url);
		} else {
			window.history.pushState({}, '', url);
		}
	}

	// Fonction pour récupérer l'état des filtres
	function stateFilter(){
		var entite_array = [];
		var categorie_array = [];
		var result_array = [];

		var page_id = jQuery('#hidden_page_id').attr('value');

		if( jQuery('#entite-legi-group_filter').length ){
			// Récupérer les slugs (value) des checkboxes cochées au lieu des IDs
			jQuery('input[type="checkbox"][name="entite-legi-group"]:checked').each(function(){ 
				entite_array.push( jQuery(this).val() ); // .val() récupère l'attribut value (slug)
			});
		}else{
			entite_array.push( jQuery('#hidden_page_term_slug').attr('value') );
		}

		if( jQuery('#categorie-actu_filter').length ){
			// Récupérer les slugs (value) des checkboxes cochées au lieu des IDs
			jQuery('input[type="checkbox"][name="categorie-actu"]:checked').each(function(){ 
				categorie_array.push( jQuery(this).val() ); // .val() récupère l'attribut value (slug)
			});
		}

		result_array.page_id = page_id;
		result_array.entite_array = entite_array;
		result_array.categorie_array = categorie_array;

		// On vérifie si des éléments sont présent pour afficher le bouton de filtre.
		// Si page global
		if( ( (result_array.entite_array).length || (result_array.categorie_array).length ) && !jQuery('#delete-filter').hasClass('filterPage') ){
			// Des éléments sont présents au sein des tableau, on affiche le bouton de filtre
			jQuery('#delete-filter').removeClass('hidden');
		}
		// si page spécifique
		else if( (result_array.categorie_array).length && jQuery('#delete-filter').hasClass('filterPage') ){
			jQuery('#delete-filter').removeClass('hidden');
		}
		else{
			jQuery('#delete-filter').addClass('hidden');
		}

		return result_array;
	}

	function checkMore(result){
		// Vérifier que result existe avant d'accéder à ses propriétés
		if (result && result.loadmore) {
			var classes = jQuery('.listing_actu_content').attr('attr-page-slug');

			jQuery('.btn_loadmore').remove();
			jQuery('.listing_actu_content').append(result.loadmore);
			jQuery('#load-more div').attr('class', classes)
		} else {
			jQuery('.btn_loadmore').remove();
		}
	}

	// Fonction générique pour tous les appels AJAX
	function performActuFilter(options = {}) {
		const defaults = {
			paged: 1,
			replaceContent: true,
			showLoader: true,
			updatePagination: true,
			skipUrlUpdate: false
		};
		
		const settings = Object.assign(defaults, options);
		
		// Récupérer l'état des filtres
		var array_result = stateFilter();
		
		// Mettre à jour l'URL si demandé (seulement pour les nouveaux filtres, pas pour la pagination)
		if (!settings.skipUrlUpdate && settings.paged === 1) {
			// Préparer les paramètres URL avec les entités et catégories utilisées
			const urlParams = {};
			
			// Ajouter les entités (exclure l'entité de la page courante s'il y en a une)
			const pageTermSlug = jQuery('#hidden_page_term_slug').attr('value');
			const selectedEntites = array_result.entite_array.filter(slug => slug && slug !== pageTermSlug);
			if (selectedEntites.length > 0) {
				urlParams.entite = selectedEntites;
			}
			
			// Ajouter les catégories
			if (array_result.categorie_array.length > 0) {
				urlParams.categorie = array_result.categorie_array;
			}
			
			// console.log('Mise à jour URL avec paramètres:', urlParams);
			updateUrlParameters(urlParams);
		}
		
		// Afficher le loader
		if (settings.showLoader) {
			jQuery('#loader-container').removeClass('hidden');
		}
		
		// Mettre à jour la pagination si demandé
		if (settings.updatePagination) {
			jQuery('#load-more').attr('attr-paged', settings.paged);
		}

		// Appel AJAX
		return jQuery.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json', 
			data: {
				action: 'actu_filter',
				paged: settings.paged,
				page_id: array_result.page_id,
				entite_array: array_result.entite_array,
				categorie_array: array_result.categorie_array,
			},
			success: function (result) {
				// Vérifier que result existe
				if (result) {
					if (settings.replaceContent) {
						// Remplacer le contenu (nouveau filtre)
						jQuery('.listing_actu_block').html('');
						if (result.articles) {
							jQuery('.listing_actu_block').append(result.articles);
						} else {
							// Si pas d'articles retournés, afficher un message par défaut
							jQuery('.listing_actu_block').append('<p class="no-results font-s">Désolé, aucun article correspondant à votre recherche.</p>');
						}
					} else {
						// Ajouter le contenu (pagination) - seulement si il y a des articles
						if (result.articles) {
							jQuery('.listing_actu_block').append(result.articles);
						}
					}
				} else {
					console.error('Réponse AJAX invalide:', result);
					if (settings.replaceContent) {
						jQuery('.listing_actu_block').html('<p class="no-results font-s">Erreur lors du chargement des articles.</p>');
					}
				}
				
				// Appeler checkMore seulement si result existe
				if (result) {
					checkMore(result);
				}
				
				if (settings.showLoader) {
					jQuery('#loader-container').addClass('hidden');
				}
			},
			error: function(xhr, status, error) {
				console.error('Erreur AJAX:', error);
				if (settings.showLoader) {
					jQuery('#loader-container').addClass('hidden');
				}
			}
		});
	}

	function triggerFilter(skipUrlUpdate = false) {
		return performActuFilter({
			paged: 1,
			replaceContent: true,
			skipUrlUpdate: skipUrlUpdate
		});
	}

	// Initialiser les filtres depuis l'URL au chargement de la page
	function initFiltersFromUrl() {
		const params = getUrlParameters();
		// console.log('Paramètres URL détectés:', params);
		
		let filtersApplied = false;
		
		// Appliquer les filtres entité
		if (params.entite && Array.isArray(params.entite)) {
			// console.log('Application des filtres entité:', params.entite);
			params.entite.forEach(entiteSlug => {
				// Chercher la checkbox par son attribut value (slug) au lieu de l'ID
				const checkbox = jQuery(`input[name="entite-legi-group"][value="${entiteSlug}"]`);
				if (checkbox.length) {
					checkbox.prop('checked', true);
					filtersApplied = true;
					// console.log('Entité cochée:', entiteSlug, checkbox.next('label').text());
				}
			});
		}
		
		// Appliquer les filtres catégorie
		if (params.categorie && Array.isArray(params.categorie)) {
			// console.log('Application des filtres catégorie:', params.categorie);
			params.categorie.forEach(categorieSlug => {
				// Chercher la checkbox par son attribut value (slug) au lieu de l'ID
				const checkbox = jQuery(`input[name="categorie-actu"][value="${categorieSlug}"]`);
				if (checkbox.length) {
					checkbox.prop('checked', true);
					filtersApplied = true;
					// console.log('Catégorie cochée:', categorieSlug, checkbox.next('label').text());
				}
			});
		}
		
		// Si des filtres sont appliqués, lancer la recherche
		if (filtersApplied) {
			// console.log('Lancement du filtre depuis l\'URL');
			triggerFilter(true); // true pour éviter de mettre à jour l'URL à nouveau
		}
	}

	// ======================================
	// GESTION CENTRALISÉE DU RESIZE
	// ======================================
	
	// Fonction de debounce pour optimiser les événements resize
	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	// Gestionnaire centralisé pour le resize
	function handleResize() {
		// Réinitialiser la hauteur des équipes
		if (typeof window.initEquipe === 'function') {
			window.initEquipe();
		}
		
		// Vérifier le menu actu
		if (typeof window.checkMenuActu === 'function') {
			window.checkMenuActu();
		}
		
		// Rafraîchir ScrollTrigger
		if (typeof ScrollTrigger !== 'undefined') {
			ScrollTrigger.refresh();
		}
		
		// Réinitialiser le barillet wheel si nécessaire (seulement sur desktop)
		if (jQuery('.block-barillet_wheel').length && typeof window.setupBarillet === 'function' && typeof window.isMobileOrTabletDevice === 'function' && !window.isMobileOrTabletDevice()) {
			window.setupBarillet();
		}
		
		// Réinitialiser le slider mobile si nécessaire
		if (typeof window.isMobileOrTabletDevice === 'function' && window.isMobileOrTabletDevice() && jQuery('.block-barillet_wheel-container').length && !jQuery('.mobile-barillet-slider').length) {
			jQuery('.block-barillet_wheel-container').addClass('isMobile');
			window.initMobileBarilletSlider();
		}
		
		// Réinitialiser les animations de scroll header
		initHeaderScrollAnimation();
	}

	// Gestionnaire resize optimisé avec debounce
	var debouncedResize = debounce(handleResize, 300);

	// ======================================
	// JQUERY READY
	// ======================================

	$(function () {
		'use strict';

		// Initialiser le slider mobile pour le barillet si on est sur mobile/tablette (voir js/barillet.js)
		if (typeof window.isMobileOrTabletDevice === 'function' && window.isMobileOrTabletDevice() && jQuery('.block-barillet_wheel-container').length) {
			jQuery('.block-barillet_wheel-container').addClass('isMobile');
			window.initMobileBarilletSlider();
		}

		// Initialiser les filtres d'image header
		initHeaderFilters();
		
		// Initialiser l'animation de scroll automatique
		initHeaderScrollAnimation();

    // Scroll to top
    var btn = $('#button');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

    // Scroll to anchor
    var $root = $('html, body');
    $('a[href^="#"]').click(function() {
      if($(this).hasClass('.anchor-link')) {
        var href = $.attr(this, 'href');
        $root.animate({scrollTop: $(href).offset().top}, 500, function() {
          window.location.hash = href;
        });
        return false;
      }
    });

    // Fonction fixe navigation
    fixeNav();

    function fixeNav() {
      var lastScrollTop = 0;
      var threshold = 200;

      $(window).scroll(function(event){
        var currentScrollTop = $(this).scrollTop();

        if (lastScrollTop < threshold){
          $('.bkgHeader').removeClass("stickcolored");
        } else {
          $('.bkgHeader').addClass("stickcolored");
        }

        if (currentScrollTop > lastScrollTop && lastScrollTop > threshold){
          $('.header').addClass("stickhidden");
        } else {
          $('.header').removeClass("stickhidden");
        }

        lastScrollTop = currentScrollTop;
      });
    }

    dropDownMobile();

    function dropDownMobile() {
      // Toogle Navigation Mobile
      $('.mobile-menu__item').click(function(){
        //Expand or collapse this panel
        $(".menu-item-has-children").not($(this)).removeClass('active');
        $(this).toggleClass('active');
      });
    }

    // SubMenu Navigation
    subMenuToggle();

    function subMenuToggle() {

      const menuH = $('.desktop-menu').outerHeight();

      $('.desktop-menu .menu-item-has-children').mouseenter(
        function(){

          if(!$(this).hasClass('active')){
            $('.desktop-menu .menu-item-has-children.active .sub-menu').stop().animate({ top: '-'+(menuH+300)+'px'}, 300, function() { });
            $(this).addClass('active');

            const subMenu = $(this).find('.sub-menu');
            $(subMenu).stop().animate({ top: menuH+'px'}, 400, function() { });
          }
        }
      );

      $(".desktop-menu .menu-item-has-children").mouseleave(function(){
        if($(this).hasClass('active')){
          $('.menu-item-has-children.active .sub-menu').stop().animate({ top: '-'+(menuH+300)+'px'}, 300, function() { });
          $(this).removeClass('active');
        }
      });
    }

    // Cards entité : voir js/cards-entite.js

    //Swiper Slider Equipe

    //On récupère l'enemble des éléments avec la classe swiper-container
    const myCustomSlider = document.querySelectorAll('.slider_equipe-container-card');

    for( let i=0; i< myCustomSlider.length; i++ ) {
      myCustomSlider[i].classList.add('swiper-container-' + i);

      switch(i){

        case 1:
          var slider = new Swiper('.swiper-container-' + i, {
            loop: true,
            slidesPerView: 2,
            stopOnLastSlide: false,
            spaceBetween: 20,
            waitForTransition: false,
            speed:20000,
            allowTouchMove: false,
            autoplay: {
              delay: 0,
            },
            // Responsive breakpoints
            breakpoints: {
              720: {
                slidesPerView: 2,
              },
              1080: {
                slidesPerView: 3,
              },
              1600: {
                slidesPerView: 4,
              }
            }
          });
          break;

        default:
          var slider2 = new Swiper('.swiper-container-' + i, {
            loop: true,
            slidesPerView: 2,
            stopOnLastSlide: false,
            spaceBetween: 20,
            waitForTransition: false,
            speed:20000,
            allowTouchMove: false,
            autoplay: {
              delay: 0,
              reverseDirection: true,
            },
            // Responsive breakpoints
            breakpoints: {
              720: {
                slidesPerView: 2,
              },
              1080: {
                slidesPerView: 3,
              },
              1600: {
                slidesPerView: 4,
              }
            }
          });
      }

    }

    // Filtre actu

    if( $('.listing_actu-filter').length ){

      $('.filter_btn').on('click', function(){
        $('.filter_btn.active').removeClass('active');
        $(this).addClass('active');
        
        let term_id = $(this).attr('attr-filter');
        let link_txt = $(this).attr('attr-link_txt');
        let taxonomie_name = $(this).attr('attr-taxo-name');

        $.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php',
          dataType: 'json',
          data: {
            action: 'actu_block_filter',
            term_id: term_id,
            link_txt: link_txt,
            taxonomie_name: taxonomie_name,
          },
          success: function (res) {
            $('.listing_actu_content').html('');
            $('.listing_actu_content').append(res);
          }
        });

      });

    }

	});

  //Init Equipe height
  window.initEquipe = function(){
    jQuery('.listing_equipe-item-content').each(function(){
      var elemH = jQuery(this).find('img').outerHeight();
      jQuery(this).css('height', elemH+60);
    });
  }

  window.initEquipe();

  // Slider IntervalEquipement

  // Helper to detect mobile
  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  // Store intervals for each slider to avoid conflicts
  var equipeIntervals = new Map();

  function startEquipeSlider($container) {
    stopEquipeSlider($container);
    var interval = setInterval(function(){
      var $active = $container.find('.listing_equipe-slider.active');
      if($active.next().length){
        $active.removeClass('active').next().addClass('active');
      } else {
        $active.removeClass('active');
        $container.find('.listing_equipe-slider:first-of-type').addClass('active');
      }
    }, 1200);
    equipeIntervals.set($container[0], interval);
  }

  function stopEquipeSlider($container) {
    var interval = equipeIntervals.get($container[0]);
    if (interval) {
      clearInterval(interval);
      equipeIntervals.delete($container[0]);
    }
    $container.find('.listing_equipe-slider').removeClass('active');
    $container.find('.listing_equipe-slider:first-of-type').addClass('active');
  }

  function destroyEquipeEvents() {
    jQuery('.listing_equipe-item-content').off('.equipeSlider');
  }

  function initEquipeSliders() {
    destroyEquipeEvents();
    if (isMobile()) {
      // Sur mobile, tous les sliders tournent en boucle automatiquement
      jQuery('.listing_equipe-item-content').each(function(){
        var $this = jQuery(this);
        stopEquipeSlider($this); // reset before starting
        $this.find('.listing_equipe-slider').removeClass('active');
        $this.find('.listing_equipe-slider:first-of-type').addClass('active');
        startEquipeSlider($this);
      });
    } else {
      // Sur desktop, slider uniquement au hover
      jQuery('.listing_equipe-item-content').each(function(){
        var $this = jQuery(this);
        stopEquipeSlider($this); // reset any running interval
        $this.find('.listing_equipe-slider').removeClass('active');
        $this.find('.listing_equipe-slider:first-of-type').addClass('active');
      });
      jQuery('.listing_equipe-item-content').on('mouseenter.equipeSlider', function(){
        var $this = jQuery(this);
        startEquipeSlider($this);
      }).on('mouseleave.equipeSlider', function(){
        var $this = jQuery(this);
        stopEquipeSlider($this);
      });
    }
  }

  // Initialisation au chargement
  jQuery(document).ready(function() {
    initEquipeSliders();
  });

  // Réinitialiser au resize (pour gérer passage mobile/desktop)
  var lastIsMobile = isMobile();
  jQuery(window).on('resize', function(){
    var currentIsMobile = isMobile();
    if (currentIsMobile !== lastIsMobile) {
      initEquipeSliders();
      lastIsMobile = currentIsMobile;
    }
  });

  // Card wheel (Savoir-faire)
  // gsap.registerPlugin("ScrollTrigger");

  //On récupère l'enemble des éléments avec la classe swiper-container
  const myCustomSlider = document.querySelectorAll('.slider_secteur_activite_content');

  for( let i=0; i< myCustomSlider.length; i++ ) {
    myCustomSlider[i].classList.add('swiper-container-' + i);

    var slider = new Swiper('.swiper-container-' + i, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // Responsive breakpoints
      breakpoints: {
        1040: {
          slidesPerView: 2,
        },
        1440: {
          slidesPerView: 3,
        },
        // 1600: {
        //   slidesPerView: 3,
        // }
      }
    });

  }


  // TEMPLATE ACTU FILTER

  if(jQuery('.template-actu').length){ 

    // Initialiser les filtres depuis l'URL au chargement de la page
    initFiltersFromUrl();

    // Gérer le bouton retour du navigateur
    window.addEventListener('popstate', function(event) {
      // Réinitialiser tous les filtres
      jQuery('input[type="checkbox"]').prop('checked', false);
      
      // Réappliquer les filtres depuis l'URL
      initFiltersFromUrl();
    });

    // Gestionnaire pour les changements de filtres (checkboxes)
    jQuery('input[type="checkbox"]').on('click', function(){
      // Utiliser la fonction factorisée
      triggerFilter();
    });

    // Gestionnaire pour supprimer tous les filtres
    jQuery('#delete-filter').on('click', function(){
      // Décocher toutes les checkboxes
      jQuery('input[type="checkbox"]:checked').prop('checked', false);
      
      // Supprimer tous les paramètres d'URL
      updateUrlParameters({});
      
      // Relancer le filtre
      triggerFilter(true); // true pour éviter de mettre à jour l'URL à nouveau
    });

    // Gestionnaire pour la pagination (Load More)
    jQuery(document).on('click', '#load-more', function() {
      var current_page = parseInt(jQuery(this).attr('attr-paged'));
      var next_page = current_page + 1;

      // Utiliser la fonction factorisée pour la pagination
      performActuFilter({
        paged: next_page,
        replaceContent: false, // Ajouter le contenu, ne pas remplacer
        skipUrlUpdate: true,   // Ne pas mettre à jour l'URL pour la pagination
        updatePagination: false // On met à jour manuellement après succès
      }).done(function() {
        // Mettre à jour le numéro de page après succès
        jQuery('#load-more').attr('attr-paged', next_page);
      });
    });

    // Menu
    var swiper= Swiper;
    var init = false;

    window.checkMenuActu = function(){

      let mobile = window.matchMedia('(max-width: 960px)');

      if(mobile.matches){
        if (!init) {
          init = true;
    
          var menuButton = document.querySelector('.menu-button');
          var openMenu = function () {
            swiper.slidePrev();
          };

          swiper = new Swiper('.swiper', {
            slidesPerView: 'auto',
            initialSlide: 1,
            resistanceRatio: 0,
            slideToClickedSlide: true,
            on: {
              slideChangeTransitionStart: function () {
                var slider = this;
                if (slider.activeIndex === 0) {
                  menuButton.classList.add('cross');
                  // required because of slideToClickedSlide
                  menuButton.removeEventListener('click', openMenu, true);
                } else {
                  menuButton.classList.remove('cross');
                }
              },
              slideChangeTransitionEnd: function () {
                var slider = this;
                if (slider.activeIndex === 1) {
                  menuButton.addEventListener('click', openMenu, true);
                }
              },
            },
          });


        }

      }

    }

    // initiaisation
    window.checkMenuActu();

  }

	// ======================================
	// GESTION DU FILTRE HEADER
	// ======================================
	
	// Fonction pour ajuster la largeur du filtre de l'image header
	function adjustFilterWidth(img) {
		// Attendre que l'image soit complètement chargée
		if (img.complete) {
			setFilterWidth(img);
		} else {
			img.addEventListener('load', function() {
				setFilterWidth(img);
			});
		}
		
		// Ajouter un listener pour le redimensionnement
		window.addEventListener('resize', function() {
			setFilterWidth(img);
		});
	}

	function setFilterWidth(img) {
		// Vérifier si on est en dessous de 1140px
		if (window.innerWidth > 1140) {
			return;
		}
		
		const imgBox = img.closest('.imgBox');
		const filter = img.nextElementSibling;
		
		if (filter && filter.classList.contains('filter')) {
			// Le filtre prend exactement la largeur de l'image
			const imgWidth = img.offsetWidth;
			filter.style.width = imgWidth + 'px';
		}
	}

	// Initialiser les filtres d'image header au chargement
	function initHeaderFilters() {
		const headerImages = document.querySelectorAll('.block-header .imgBox img');
		headerImages.forEach(img => {
			adjustFilterWidth(img);
		});
	}

	// Animation de scroll infini pour imgBox
	function initHeaderScrollAnimation() {
		const imgBoxes = document.querySelectorAll('.block-header .imgBox.infinite-scroll');
		
		imgBoxes.forEach((imgBox, index) => {
			const img = imgBox.querySelector('img');
			if (!img) return;
			
			// Créer le wrapper si il n'existe pas
			if (!imgBox.querySelector('.infinite-scroll-wrapper')) {
				createInfiniteScroll(imgBox, img, index);
			}
			
		// Activer/désactiver selon la largeur d'écran
		const wrapper = imgBox.querySelector('.infinite-scroll-wrapper');
		if (wrapper) {
			if (window.innerWidth <= 1140) {
				wrapper.classList.add('active');
				// Si la gestion manuelle n'est pas encore active, l'initialiser
				if (!wrapper._manualScrollInitialized) {
					const imgWidth = wrapper._imgWidth;
					if (imgWidth) {
						initManualScroll(wrapper, imgWidth, index);
						wrapper._manualScrollInitialized = true;
					}
				}
				// S'assurer que l'animation redémarre correctement en mobile
				wrapper.style.animation = '';
			} else {
				// Desktop : désactiver l'animation et réinitialiser les transforms
				wrapper.classList.remove('active');
				wrapper.style.animation = 'none';
				wrapper.style.transform = 'translateX(0px)';
				wrapper.style.setProperty('--start-x', '0px');
			}
		}
		});
	}
	
	
	// Nettoyer les animations existantes
	function cleanupHeaderScrollAnimations() {
		// Supprimer les wrappers d'animation existants
		const existingWrappers = document.querySelectorAll('[class*="infinite-scroll-wrapper"]');
		existingWrappers.forEach(wrapper => {
			// Restaurer l'image originale
			const img = wrapper.querySelector('img:first-child');
			if (img && wrapper.parentNode) {
				wrapper.parentNode.appendChild(img);
			}
			wrapper.remove();
		});
		
		// Supprimer les styles d'animation existants
		const existingStyles = document.querySelectorAll('style[data-animation="infinite-scroll"]');
		existingStyles.forEach(style => style.remove());
	}
	
	function createInfiniteScroll(imgBox, img, index) {
		const imgWidthOriginal = img.naturalWidth;
		const imgHeightOriginal = img.naturalHeight;
		const imgHeight = 300;
		const imgWidth = (imgWidthOriginal / imgHeightOriginal) * imgHeight;
    
		
		// Créer un wrapper pour l'animation infinie
		const wrapper = document.createElement('div');
		wrapper.className = `infinite-scroll-wrapper infinite-scroll-wrapper-${index} active`;
		wrapper.style.cssText = `
			display: flex;
			width: max-content;
			height: ${imgHeight}px;
		`;
		
		// Dupliquer l'image pour un scroll continu
		const imgClone = img.cloneNode(true);
		
		// Styliser toutes les images
		[img, imgClone].forEach(image => {
			image.style.cssText = `
				width: ${imgWidth}px;
				height: ${imgHeight}px;
				flex-shrink: 0;
				object-fit: cover;
			`;
		});
		
		// Insérer le wrapper et les images
		imgBox.appendChild(wrapper);
		wrapper.appendChild(img);
		wrapper.appendChild(imgClone);
		
		// Initialiser la variable CSS pour l'animation
		wrapper.style.setProperty('--start-x', '0px');
		
		// Créer l'animation CSS continue
		const style = document.createElement('style');
		style.setAttribute('data-animation', 'infinite-scroll');
		style.textContent = `
			@keyframes infiniteScroll_${index} {
				0% { 
					transform: translateX(var(--start-x, 0));
				}
				100% { 
					transform: translateX(calc(var(--start-x, 0) - ${imgWidth}px));
				}
			}
			
			.infinite-scroll-wrapper-${index}.active {
				animation: infiniteScroll_${index} 45s linear infinite;
			}
			
			@media screen and (max-width: 1140px) {
				.infinite-scroll-wrapper-${index} {
					pointer-events: auto;
					cursor: grab;
				}
				
				.infinite-scroll-wrapper-${index}:active {
					cursor: grabbing;
				}
			}
			
			@media screen and (min-width: 1141px) {
				.infinite-scroll-wrapper-${index} {
					cursor: default;
				}
			}
			
			.infinite-scroll-wrapper-${index} img {
				pointer-events: none;
				user-select: none;
			}
		`;
		document.head.appendChild(style);
		
		// Stocker imgWidth et références aux images dans wrapper
		wrapper._imgWidth = imgWidth;
		wrapper._img1 = img;
		wrapper._img2 = imgClone;
		
		// Gestion manuelle du scroll UNIQUEMENT en dessous de 1140px
		if (window.innerWidth <= 1140) {
			initManualScroll(wrapper, imgWidth, index);
		}
	}
	
	// Fonction pour gérer le scroll manuel
	function initManualScroll(wrapper, imgWidth, index) {
		let isDragging = false;
		let startX = 0;
		let dragOffset = 0;
		let basePosition = 0;
		let lastRepositionTime = 0;
		const REPOSITION_THROTTLE = 50; // ms - empêcher les repositionnements trop rapides
		
		// Fonctions de gestion d'événements avec vérification de la largeur d'écran
		function handleStart(e) {
			// Ne rien faire si on est au-dessus de 1140px
			if (window.innerWidth > 1140) return;
			
			isDragging = true;
			
			// Capturer la position de départ de la souris/doigt
			const clientX = e.touches ? e.touches[0].clientX : e.clientX;
			startX = clientX;
			
			// Capturer la position actuelle RÉELLE de l'image avec getComputedStyle
			const computedStyle = window.getComputedStyle(wrapper);
			const matrix = computedStyle.transform;
			let currentPos = 0;
			
			if (matrix && matrix !== 'none') {
				// Parser la matrice de transformation pour obtenir translateX
				const matrixValues = matrix.match(/matrix.*\((.+)\)/);
				if (matrixValues) {
					const values = matrixValues[1].split(', ');
					currentPos = parseFloat(values[4]); // translateX est dans values[4]
				}
			} else {
				// Fallback : lire depuis style.transform
				const currentTransform = wrapper.style.transform || 'translateX(0px)';
				const match = currentTransform.match(/translateX\((-?\d+\.?\d*)px\)/);
				currentPos = match ? parseFloat(match[1]) : 0;
			}
			
		// Normaliser la position pour être dans la plage [-imgWidth, 0]
		while (currentPos > 0) {
			currentPos = currentPos - imgWidth;
		}
		while (currentPos < -imgWidth) {
			currentPos = currentPos + imgWidth;
		}
		
		basePosition = currentPos;
			
			// Arrêter l'animation CSS et forcer la position
			wrapper.classList.remove('active');
			wrapper.style.animation = 'none';
			wrapper.style.setProperty('--start-x', `${basePosition}px`);
			wrapper.style.transform = `translateX(${basePosition}px)`;
			
			// Réinitialiser dragOffset et le throttle pour le nouveau glissement
			dragOffset = 0;
			lastRepositionTime = 0;
			
			e.preventDefault();
		}
		
		function handleMove(e) {
			// Ne rien faire si on est au-dessus de 1140px
			if (window.innerWidth > 1140) {
				// Si on était en train de dragger, arrêter le drag
				if (isDragging) {
					isDragging = false;
				}
				return;
			}
			
			if (!isDragging) return;
			
			const clientX = e.touches ? e.touches[0].clientX : e.clientX;
			const deltaX = clientX - startX;
			
			// Calculer le déplacement total
			dragOffset = deltaX;
			let newPosition = basePosition + dragOffset;
			
			// Déplacer les images dans le DOM pour créer l'illusion de scroll infini
			const now = Date.now();
			if (newPosition <= -imgWidth && now - lastRepositionTime > REPOSITION_THROTTLE) {
				// Déplacer la première image à la fin
				const firstImg = wrapper._img1;
				const secondImg = wrapper._img2;
				wrapper.removeChild(firstImg);
				wrapper.appendChild(firstImg);
				// Réassigner les références
				wrapper._img1 = secondImg;
				wrapper._img2 = firstImg;
				// Réinitialiser la position
				newPosition = newPosition + imgWidth;
				basePosition = newPosition;
				startX = clientX;
				dragOffset = 0;
				lastRepositionTime = now;
			} else if (newPosition >= 0 && now - lastRepositionTime > REPOSITION_THROTTLE) {
				// Déplacer la deuxième image au début
				const firstImg = wrapper._img1;
				const secondImg = wrapper._img2;
				wrapper.removeChild(secondImg);
				wrapper.insertBefore(secondImg, firstImg);
				// Réassigner les références
				wrapper._img1 = secondImg;
				wrapper._img2 = firstImg;
				// Réinitialiser la position
				newPosition = newPosition - imgWidth;
				basePosition = newPosition;
				startX = clientX;
				dragOffset = 0;
				lastRepositionTime = now;
			}
			
			// Appliquer la transformation
			wrapper.style.transform = `translateX(${newPosition}px)`;
			
			e.preventDefault();
		}
		
		function handleEnd(e) {
			// Ne rien faire si on est au-dessus de 1140px
			if (window.innerWidth > 1140) {
				isDragging = false;
				return;
			}
			
			if (!isDragging) return;
			isDragging = false;
			
			// Calculer la position finale
			let finalPosition = basePosition + dragOffset;
			
			// Normaliser finalPosition pour être dans la plage [-imgWidth, 0]
			while (finalPosition > 0) {
				finalPosition = finalPosition - imgWidth;
			}
			while (finalPosition < -imgWidth) {
				finalPosition = finalPosition + imgWidth;
			}
			
			// Synchroniser complètement : forcer la position ET mettre à jour --start-x
			wrapper.style.setProperty('--start-x', `${finalPosition}px`);
			wrapper.style.transform = `translateX(${finalPosition}px)`;
			
			// Forcer un reflow pour s'assurer que la position est appliquée
			void wrapper.offsetHeight;
			
			// Reprendre l'animation depuis la position actuelle
			wrapper.style.animation = '';
			wrapper.classList.add('active');
		}
		
		// Mouse events
		wrapper.addEventListener('mousedown', handleStart);
		document.addEventListener('mousemove', handleMove);
		document.addEventListener('mouseup', handleEnd);
		document.addEventListener('mouseleave', handleEnd);
		
		// Touch events
		wrapper.addEventListener('touchstart', handleStart, { passive: false });
		document.addEventListener('touchmove', handleMove, { passive: false });
		document.addEventListener('touchend', handleEnd);
		document.addEventListener('touchcancel', handleEnd);
	}

	// ======================================
	// ÉCOUTEUR RESIZE CENTRALISÉ
	// ======================================
	
	// Ajouter l'écouteur resize centralisé
	window.addEventListener('resize', debouncedResize);

})(jQuery, this);


